import { render, staticRenderFns } from "./basic-info-table.vue?vue&type=template&id=162bcdde&scoped=true"
import script from "./basic-info-table.vue?vue&type=script&lang=js"
export * from "./basic-info-table.vue?vue&type=script&lang=js"
import style0 from "./basic-info-table.vue?vue&type=style&index=0&id=162bcdde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162bcdde",
  null
  
)

export default component.exports